<template>
	<f7-page class="" id="debtorList">
		<page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverContacts" subNavTitle="DebtorList" :menuAccess="false"></page-nav-bar>

		<f7-searchbar class="search"
			cancel-link="Cancel"
			search-list="#debtors-list"
			placeholder="Search in debtor list"
			@searchbar:search="onSearch">
		</f7-searchbar>
		<div class="layoutSubtitle"/>
		<f7-list class="searchbar-not-found">
      <f7-list-item title="Nothing found"></f7-list-item>
    </f7-list>

    <f7-list media-list class="searchbar-found" id="debtors-list">
      <!-- <f7-list-group v-for="(group, key) in contacts" :key="key"> -->
      <f7-list-item
      swipeout
      v-for="debtor in debtors"
      :title="debtor.debtorName"
      :subtitle="debtor.debtorEmail"
      :key="debtor.debtorBank"
      v-bind:media="'<div class=\'manualChip\'>'+contact.label[0]+'</div>'">
        <f7-swipeout-actions>
          <f7-swipeout-button delete>Delete</f7-swipeout-button>
        </f7-swipeout-actions>
      <!--<f7-link class= "removeIcon" icon-f7="icon-close_round_fill" color="red" @click="removeContact(contact)"></f7-link>-->
      </f7-list-item>
      <!-- </f7-list-group> -->
    </f7-list>
	</f7-page>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'debtorList',
  components: {
    'page-nav-bar': pageNavBar
  },
  data: () => {
    return {
      debtors: []
    }
  },
  created () {
    this.$f7.params.swipePanel = 'left'
    const that = this
    this.$bus.$on('refresh-cache-contacts', () => {
      that.setContacts()
    })
  },
  mounted () {
    this.setContacts()
  },
  methods: {
    onSearch: function (query, found) {
      var self = this
      for (var k in self.contacts) {
        if (self.contacts.hasOwnProperty(k)) {
          for (var i = 0; i < self.contacts[k].length; i++) {
            if (self.contacts[k][i].label.indexOf(query) >= 0 || self.contacts[k][i].name.indexOf(query) >= 0 || query.trim() === '') {
              if (!found.hasOwnProperty(self.contacts[k])) {
                found[self.contacts[k]] = []
              }
              found[self.contacts[k]].push(self.contacts[k][i].id)
            }
          }
        }
      }
      return found
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMDebtorList.vue?79689ef5